import { useState } from 'react'
import { Grid, Menu, MenuList } from '@material-ui/core'
import { ExpandLess, ExpandMore } from '@material-ui/icons'
import { useStyles } from './styles'

const same = () => {}
const origin = { vertical: 'top', horizontal: 'center' }

const CollapsibleList = ({ data = [], getItemLabel = item => item?.name, classes, onSelect = same, ...props }) => {
   const styles = classes || useStyles()
   const [anchorEl, setAnchorEl] = useState(null)
   const handleOpen = e => setAnchorEl(prev => (!prev ? e.currentTarget : null))
   const open = Boolean(anchorEl)
   const [firstItem, ...items] = data
   const moreThanOneItem = data?.length > 1
   return (
      <Grid container onClick={handleOpen} className={styles?.details}>
         <Grid container item className={styles?.detailList}>
            <div>{getItemLabel(firstItem) || ''}</div>
            {moreThanOneItem && (
               <Menu
                  open={open}
                  anchorEl={anchorEl}
                  anchorOrigin={props?.anchorOrigin || origin}
                  transformOrigin={props?.transformOrigin || origin}
                  className={styles?.menu}
               >
                  <MenuList className={styles?.menuList}>
                     {items?.map((item, idx) => (
                        <Grid item key={idx} className={styles?.detailItem} onClick={() => onSelect(item)}>
                           {getItemLabel(item)}
                        </Grid>
                     ))}
                  </MenuList>
               </Menu>
            )}
         </Grid>
         {moreThanOneItem && <Grid item>{open ? <ExpandLess /> : <ExpandMore />}</Grid>}
      </Grid>
   )
}

export default CollapsibleList
